import React from 'react'

import Dialog, { DialogProps } from '@components/shared/Dialog'

interface Props extends Omit<DialogProps, 'cancelBtn' | 'okBtn'> {
  message: string
  onConfirm?: () => void
  onCancel?: () => void
  okDisabled?: boolean
  cancelDisabled?: boolean
}

const ConfirmDeleteDialog: React.FC<Props> = ({
  message,
  onConfirm,
  onCancel,
  okDisabled,
  cancelDisabled,
  ...props
}: Props) => {
  return (
    <Dialog
      {...props}
      okBtn={{ action: onConfirm, disabled: okDisabled }}
      cancelBtn={{ action: onCancel, disabled: cancelDisabled }}
      destructive
      maxWidth={350}>
      <p className="whitespace-normal">{message}</p>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
